import cn from 'classnames'
import { isValidElement, memo } from 'react'

import { IContentProps } from './models'

import styles from './Content.module.scss'

export const Content = memo<IContentProps>(({ activeIndex, validChildren }) => {
  return (
    <div className={cn(styles.content)}>
      {isValidElement(validChildren[activeIndex]) ? validChildren[activeIndex] : null}
    </div>
  )
})
